import { SvgIcon } from '@mui/material';

export const TireIcon = ({
  width = 24,
  height = 24,
  color = 'currentColor',
  spokeColor = '#2D3748',
}: {
  width?: string | number;
  height?: string | number;
  color?: string;
  spokeColor?: string;
}) => {
  return (
    <SvgIcon viewBox="0 0 100 100" style={{ width, height }} htmlColor={color}>
      {/* Main Tire and Rim Group */}
      <g>
        {/* Tire Tread */}
        <circle
          cx="50"
          cy="50"
          r="45"
          fill={spokeColor}
          stroke={color}
          strokeWidth="2"
        />

        {/* Tread Marks */}
        <g fill="#E2E8F0">
          <rect x="46" y="0" width="8" height="12" rx="2" />
          <rect x="46" y="88" width="8" height="12" rx="2" />
          <rect x="0" y="46" width="12" height="8" rx="2" />
          <rect x="88" y="46" width="12" height="8" rx="2" />
          <g transform="rotate(45 50 50)">
            <rect x="46" y="0" width="8" height="12" rx="2" />
            <rect x="46" y="88" width="8" height="12" rx="2" />
            <rect x="0" y="46" width="12" height="8" rx="2" />
            <rect x="88" y="46" width="12" height="8" rx="2" />
          </g>
        </g>

        {/* Rim */}
        <circle cx="50" cy="50" r="34" fill="#FFFFFF" />
        <circle
          cx="50"
          cy="50"
          r="34"
          stroke={color}
          strokeWidth="4"
          fill="none"
        />

        {/* Spokes */}
        <g stroke={spokeColor} strokeWidth="5" strokeLinecap="round">
          <line x1="50" y1="50" x2="84" y2="50" />
          <line x1="50" y1="50" x2="16" y2="50" />
          <line x1="50" y1="50" x2="50" y2="16" />
          <line x1="50" y1="50" x2="50" y2="84" />
          <line x1="50" y1="50" x2="74" y2="26" />
          <line x1="50" y1="50" x2="26" y2="74" />
          <line x1="50" y1="50" x2="26" y2="26" />
          <line x1="50" y1="50" x2="74" y2="74" />
        </g>

        {/* Center Hub */}
        <circle
          cx="50"
          cy="50"
          r="8"
          fill={spokeColor}
          stroke={color}
          strokeWidth="2"
        />
        <circle
          cx="50"
          cy="50"
          r="4"
          fill={spokeColor}
          stroke={color}
          strokeWidth="1.5"
        />
      </g>
    </SvgIcon>
  );
};
